import { useState } from "react";
import { api } from "../api";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "./tailwind/dialog";
import { Button } from "./tailwind/button";

export const TagDeleteDialog = ({
  open,
  tagToDelete,
  setTagToDelete,
  customerId,
}) => {
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const handleDeleteConfirm = async () => {
    setIsDeleteLoading(true);
    try {
      await api.tag.delete(tagToDelete.id);
      // Data will be refreshed automatically by useFindMany
      setTagToDelete(null);
      api.deleteContactTags({ tagId: tagToDelete.id, customerId: customerId });
    } catch (e) {
      console.log(e);
    }
    setIsDeleteLoading(false);
  };

  const handleDeleteCancel = () => {
    setTagToDelete(null);
  };

  return (
    <Dialog
      key="dialog_delete_tag"
      open={open}
      onClose={() => handleDeleteCancel()}
    >
      <DialogTitle>Delete this tag</DialogTitle>
      <DialogBody className="flex-1 overflow-y-auto scrollbar">
        <p>
          Are you sure you want to delete the tag <b>{tagToDelete?.name}</b>?
        </p>
        {tagToDelete?.contactsCount > 0 && (
          <p className="mt-2 text-red-600 font-semibold">
            Warning: This tag is associated with {tagToDelete.contactsCount}{" "}
            contact
            {tagToDelete.contactsCount > 1 ? "s" : ""}.
          </p>
        )}
      </DialogBody>
      <DialogActions>
        <Button
          color="secondaryButton"
          onClick={() => handleDeleteCancel()}
          disabled={isDeleteLoading}
          className="min-w-[100px] h-10"
        >
          Cancel
        </Button>
        <Button
          color="primaryButton"
          onClick={() => handleDeleteConfirm()}
          className="min-w-[100px] h-10"
          loading={isDeleteLoading}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
